<template>
  <IncomingOrderDetail :is-edit="true" />
</template>

<script>
import IncomingOrderDetail from './detail';

export default {
  name: 'IncomingOrderEdit',
  components: { IncomingOrderDetail },
};
</script>

<style scoped>

</style>
